module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"pageTitle":"История платежей","refunded":"Возвращен","currency":{"RUB":"рублей"}}}')
  delete Component.options._Ctor
}
